<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
  <div class="subBlockContent" id="addsubscriptions">
    <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div>
      <div class="row filter-wrapper">
        <div class="col-md-6">
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../images/new_ui/filter.png">
            </div>
            <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchAnnuity" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'"
              (ngModelChange)="filterAnnuityItems()">
          </div>
        </div>
        <!-- # brand filter -->
        <div class="listpart col-md-6">
          <!-- <mat-form-field class="select-wrapper">
            <mat-select placeholder="Subscription Type" [(ngModel)]="selectedSubscriptionType"
              (change)="changeSubscriptionType($event)">
              <mat-option [value]="subscriptionType?.value" *ngFor="let subscriptionType of cspItemList">
                {{subscriptionType?.displayText}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <ng-select class="customDropdwon" [items]="cspItemList" bindValue="value" bindLabel="displayText" placeholder="Subscription Type" [(ngModel)]="selectedSubscriptionType" (change)="changeSubscriptionType()">
          </ng-select>
        </div>
      </div>
        <div class="col-md-12 align-center" *ngIf="!annuityItems?.length && loadContent">
          <label class="noData-label">
            <!-- We couldn’t find any annuity items -->
          </label>
        </div>
        <div *ngIf="annuityItems?.length && loadContent">
        <div class="shared-outer-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="align-left" style="width: 60%">DESCRIPTION</th>
                <th scope="col" class="align-right" style="width: 20%; text-align: right;">PRICE</th>
                <th scope="col" class="align-center" style="width: 10%">QTY</th>
                <th scope="col" class="align-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let annuityItem of annuityItemsFilter">
                <td>
                  <span class="description-popup">{{annuityItem?.description}}</span>
                  <div class="result-info">
                    <div class="produc-secondary-title-wrapper">
                      <span class="light-text">STOCK CODE:&nbsp;</span>
                      <span>{{annuityItem?.stockCode}}</span>
                    </div>
                  </div>
                </td>
                <td class="align-right" style="position: relative;vertical-align: middle;text-align: right;">
                  {{annuityItem?.itemPrice}}
                  <span *ngIf="annuityItem?.billingFrequency == '1'">/mth</span>
                  <span *ngIf="annuityItem?.billingFrequency == 'Y'">/yr</span>
                </td>
                <td class="align-center" style="position: relative;vertical-align: middle;">
                  <input class="align-center input-wrapper input-wrapper-small" [disabled]="annuityItem.disableQty" [(ngModel)]="annuityItem.quantity"
                    (keypress)="_keyPress($event)" type="text" (blur)="changeQty(annuityItem)">
                  <mat-icon matSuffix class="editmpnidicon align-top" *ngIf="annuityItem?.minMaxQtyText" placement="bottom"
                    ngbTooltip="{{annuityItem?.minMaxQtyText}}">info</mat-icon>
                </td>
                <td class="align-center" style="vertical-align: middle;">
                  <button mat-button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton"
                    *ngIf="!annuityItem?.isExisting && !hideAddButton" (click)="AddAnnuityItem(annuityItem)">Add</button>
                  <button mat-button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton"
                    *ngIf="annuityItem?.isExisting" (click)="AddAnnuityItem(annuityItem)">Update</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
          <div class="button-center">
            <button *ngIf="annuityItems?.length && loadContent" class="button button-red button-large"
            (click)="finishAddSubscriotions()">Continue</button>
          </div>
        </div>
    </div>
  </div>
</div>
